import { Droplets, Building2, CloudRain, Hammer, Wind, type LucideIcon } from "lucide-react";

/**
 * Shared service icon registry. Posts in the "services" section may set
 * `metadata.icon` to one of these keys to render an associated lucide icon.
 */
export const iconMap: Record<string, LucideIcon> = {
  Droplets,
  Building2,
  CloudRain,
  Hammer,
  Wind,
};

/** Shape of the JSON `metadata` column for service-section posts. */
export type ServiceMeta = {
  icon?: keyof typeof iconMap | string;
  features?: string[];
} | null;
